style= require('./assets.styl')

ul.sports
  .previous((click)=this.prev())
    ft-icon(name="ui--left")
  i-scroll(direction="horizontal", native="true")
    each sport in sports
      li.sports-item(class={'active':(this.sport === sport)},(click)=this.setSport(sport))= sport
  .next((click)=this.next())
    ft-icon(name="ui--right")
ft-tabs
  each tab in tabContexts
    ft-tab(
      (click)=this.setTab(tab),
      active=this.tab === tab
    )= tabText[tab]

if this.tab === 'seasons'
  if seasons && seasons.length
    table.seasons
      tr.title
        th.header.sortable(
          (click)=this.sortBy('name'))= 'League'
          ft-icon(name=this.sortIcon('Name'))
        th.header.sortable(
          (click)=this.sortBy('season'))= 'Season'
          ft-icon(name=this.sortIcon('season'))
        th.header= 'Icon'
        th.form
          span= 'File'
          span= 'Action'
      each season in sortedSeasons
          tr
            td.league(
              header='season.name',
              title=season.name)
              = season.name
            td.season(
              header='season.season',
              title=season.season)
              = season.season
            td
              img.season-icon(src=season.iconUrl)
            td(header="Icon")
              form.icon-col
                input(type="file")
                ft-button(success, data-season=season._id,(click)=this.uploadImg(e))= 'upload'
if this.tab === 'teams'
  .teams
    select((change)=this.setSeason(e.target.value))
      option(value="")= 'select a season'
      each season in sortedSeasons
        option(value=season, selected=this.season === season)= season.name
  if this.teams && this.teams.length

    table.teams
      tr.title
        th.header='name'
        th.header='emblem'
        th.form
          span='File'
          span='Action'
      each team in this.teams
        tr
          td(header="Name").league= team.name
          td(header="Emblem").emblem
            img.season-icon(src=team.iconUrl)
          td(header="Emblem").form
            form.icon-col
              input(type="file")
              ft-button(success, data-team=team._id, (click)=this.uploadImg(e))='upload'


